import { WireLandlordQuotePayload } from 'scenes/landlord/api/quote/types';
import {
  Excess,
  InsuranceOptionBase,
  PaymentFrequency,
  Campaign,
  CoverType,
} from 'scenes/common/types';

export enum LandlordCoverSubSection {
  BuildingExcess = 'Building excess',
  ContentsExcess = 'Contents excess',
  OptionalExtras = 'Optional extras',
}

export enum OptionalExtra {
  Unspecified = '',
  TenantDamage = 'TenantDamage',
  LossOfRent = 'LossofRent',
  FusionBuilding = 'FusionBuilding',
  FusionContent = 'FusionContent',
  RentDefault = 'RentDefault',
}

export enum ExcessType {
  Unspecified = '',
  Standard = 'Standard',
  Additional = 'Additional',
}

export type InsuranceOption = InsuranceOptionBase & {
  coverType: CoverType;
};

export type QuoteUserSelections = {
  buildingExcess: Excess;
  contentsExcess: Excess;
};

export type LandlordQuoteDetails = {
  payload: WireLandlordQuotePayload;
  insuranceOptions: InsuranceOption[];
  buildingExcesses: Excess[];
  contentsExcesses: Excess[];
  userSelections: QuoteUserSelections;
  saveQuoteEmailAddress?: string;
  recalculatedInstalments?: {
    firstInstalment: string;
    monthlyInstalment: string;
  };
  receiptNumber?: string;
  campaigns: Campaign[];
};

export interface CoverOptionsData {
  preselectedPaymentFrequency: PaymentFrequency;
  selectedExtras: string[];
}
